import { c as _c } from "react/compiler-runtime";
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */
import { useMutation } from '@tanstack/react-query';
import type { MutationFunction, UseMutationOptions, UseMutationResult } from '@tanstack/react-query';
import type { GetSavingsCalculationReq, HTTPValidationError, SavingsCalculationResponse } from '../model';
import { customFetch } from '../../fetcher';
type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];
export const getGetSavingsCalculationUrl = () => {
  return `/api/v1/model-catalog/savings-calculation`;
};

/**
 * @summary Get Savings Calculation Endpoint
 */
export const getSavingsCalculation = async (getSavingsCalculationReq: GetSavingsCalculationReq, options?: Parameters<typeof customFetch>[1]): Promise<SavingsCalculationResponse> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<SavingsCalculationResponse>(getGetSavingsCalculationUrl(), {
    ...options,
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...getHeaders(options?.headers)
    },
    body: JSON.stringify(getSavingsCalculationReq)
  });
};
export const getGetSavingsCalculationMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof getSavingsCalculation>>, TError, GetSavingsCalculationMutationVariables, TContext>;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<Awaited<ReturnType<typeof getSavingsCalculation>>, TError, GetSavingsCalculationMutationVariables, TContext> => {
  const mutationKey = ['getSavingsCalculation'];
  const {
    mutation: mutationOptions,
    request: requestOptions
  } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
    ...options,
    mutation: {
      ...options.mutation,
      mutationKey
    }
  } : {
    mutation: {
      mutationKey
    },
    request: undefined
  };
  const mutationFn: MutationFunction<Awaited<ReturnType<typeof getSavingsCalculation>>, GetSavingsCalculationMutationVariables> = props => {
    const {
      data
    } = props ?? {};
    return getSavingsCalculation(data, requestOptions);
  };
  return {
    mutationFn,
    ...mutationOptions
  };
};
export type GetSavingsCalculationMutationResult = NonNullable<Awaited<ReturnType<typeof getSavingsCalculation>>>;
export type GetSavingsCalculationMutationBody = GetSavingsCalculationReq;
export type GetSavingsCalculationMutationError = HTTPValidationError;
export type GetSavingsCalculationMutationVariables = {
  data: GetSavingsCalculationReq;
};

/**
 * @summary Get Savings Calculation Endpoint
 */
export const useGetSavingsCalculation = options => {
  const $ = _c(2);
  let t0;
  if ($[0] !== options) {
    t0 = getGetSavingsCalculationMutationOptions(options);
    $[0] = options;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useMutation(t0);
};